function changeSliderFacetLabel() {
  if (document.body.classList.contains("post-type-archive-offer")) {
    document.addEventListener("facetwp-loaded", function () {
      if (FWP.buildQueryString() !== "") {
        window.scrollTo({
          top: 180,
          behavior: "smooth",
        });
      }

      var count = FWP.settings.pager.total_rows;
      document.getElementById("facetwp-results-count").textContent = count;

      FWP.hooks.addAction("facetwp/set_label/slider", function ($this) {
        // Replace 'my_slider_facet_name' with the name of your Slider facet.
        var facet_name = "range";

        if ($this.nodes[0].attributes["data-name"].value == facet_name) {
          // Get all settings.
          var min = FWP.settings[facet_name]["lower"];
          var max = FWP.settings[facet_name]["upper"];
          var format = FWP.settings[facet_name]["format"];
          var opts = {
            decimal_separator: FWP.settings[facet_name]["decimal_separator"],
            thousands_separator:
              FWP.settings[facet_name]["thousands_separator"],
          };
          var from = nummy(min).format(format, opts);
          var to = nummy(max).format(format, opts);

          var label =
            '<span class="facet-label">' +
            wpGlobals.hinnavahemik_string +
            ": " +
            "</span>" +
            '<span class="slider-min">' +
            FWP.settings[facet_name]["prefix"] +
            from +
            FWP.settings[facet_name]["suffix"] +
            "</span>" +
            "-" + // Replace the — icon with a right arrow icon
            '<span class="slider-max">' +
            FWP.settings[facet_name]["prefix"] +
            to +
            // + 'FWP.settings[facet_name]['suffix']';
            "€" +
            "</span>";

          $this.find(".facetwp-slider-label").html(label);
        }
      });

      function showResetButtons() {
        // Check if any facet has a selection
        let anyFacetSelected = false;

        // Loop through all facets and check if any facet has selected values
        for (let facet in FWP.facets) {
          if (FWP.facets[facet].length > 0) {
            anyFacetSelected = true;
            break; // Exit the loop if a selected facet is found
          }
        }

        // Show or hide the reset button based on facet selection
        const resetButtons = document.querySelectorAll(".facetwp-reset");

        resetButtons.forEach(function (resetButton) {
          if (anyFacetSelected) {
            resetButton.classList.add("show");
          } else {
            resetButton.classList.remove("show");
          }
        });
      }

      showResetButtons();
    });
  }
}

function activeFacets() {
  document.addEventListener("facetwp-loaded", function () {
    // Check if the body has the class 'archive-offer'
    if (document.body.classList.contains("post-type-archive-offer")) {
      function activateFacets() {
        document.body.classList.add("facets-active");
        document.body.classList.add("all-facets-visible");

        window.scrollTo({
          top: 180,
          behavior: "smooth",
        });
      }

      // Show all offers button
      const allOffersBtn = document.querySelector("[data-show-all-offers]");

      if (allOffersBtn) {
        // Event listener for the button click
        allOffersBtn.addEventListener("click", function () {
          // Activate facets
          activateFacets();

          const url = new URL(window.location);
          url.searchParams.set("all", "true");
          window.history.pushState({}, "", url);
        });
      }

      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has("all")) {
        activateFacets();
      }

      let isFacetSelected = false;

      // Iterate through all facets to check if any are selected
      for (let facet in FWP.facets) {
        if (FWP.facets[facet].length > 0) {
          isFacetSelected = true;
          break;
        }
      }

      // Add or remove the class 'facet-active' based on whether any facets are selected
      if (isFacetSelected) {
        document.body.classList.add("facets-active");

        if (document.body.classList.contains("all-facets-visible")) {
          document.body.classList.remove("all-facets-visible");
        }
      } else {
        // document.body.classList.remove("facets-active");
        document.body.classList.add("all-facets-visible");
      }

      const resetBtn = document.querySelector(".facetwp-reset");

      resetBtn.addEventListener("click", function () {
        document.body.classList.add("all-facets-visible");
      });

      const landingBtn = document.querySelector(".show-offers-landing-view");

      landingBtn.addEventListener("click", function () {
        const url = new URL(window.location);
        const urlParams = url.searchParams;

        if (urlParams.has("all")) {
          // Remove 'all' parameter from the URL
          urlParams.delete("all");
          window.history.pushState({}, "", url.pathname + url.search);
        }

        if (
          document.body.classList.contains("all-facets-visible") &&
          document.body.classList.contains("facets-active")
        ) {
          document.body.classList.remove("all-facets-visible");
          document.body.classList.remove("facets-active");
        }
      });
    }
  });
}

function showSelectedFilters() {
  document.addEventListener("facetwp-loaded", function () {
    var activeFilters = [];

    // Iterate through each facet
    var facets = document.querySelectorAll(".facetwp-facet");
    facets.forEach(function (facet) {
      var facetName = facet.getAttribute("data-name");
      var facetType = facet.getAttribute("data-type");
      var selectedValues = FWP.facets[facetName];

      // Check if the facet has any selected values
      if (selectedValues && selectedValues.length > 0) {
        if (
          facetType === "checkboxes" ||
          facetType === "radio" ||
          facetType === "dropdown" ||
          facetType === "select"
        ) {
          // For checkboxes, radios, dropdowns, and select facets
          var checkedItems = facet.querySelectorAll(
            ".facetwp-checkbox.checked, .facetwp-radio.checked, option:checked"
          );
          checkedItems.forEach(function (item) {
            var displayValue = item.querySelector(".facetwp-display-value");
            if (displayValue) {
              activeFilters.push(displayValue.textContent.trim());
            } else {
              // Fallback if 'facetwp-display-value' class is not found
              activeFilters.push(item.textContent.replace(/\d+$/, "").trim());
            }
          });
        } else if (facetType === "fselect") {
          // For fselect facets
          var selectedOptions = facet.querySelectorAll(".fs-option.selected");
          selectedOptions.forEach(function (option) {
            var labelElement = option.querySelector(".fs-option-label");
            if (labelElement) {
              activeFilters.push(labelElement.textContent.trim());
            }
          });
        } else if (facetType === "search") {
          // For search facets
          var searchInput = facet.querySelector(".facetwp-search");
          var searchValue = searchInput ? searchInput.value.trim() : "";
          if (searchValue) {
            activeFilters.push(searchValue);
          }
        } else if (facetType === "date_range" || facetType === "date") {
          // For date range facets
          var startInput = facet.querySelector(".facetwp-date-min");
          var endInput = facet.querySelector(".facetwp-date-max");

          var startDate = startInput ? startInput.value : "";
          var endDate = endInput ? endInput.value : "";

          // Format dates if valid
          function formatDate(dateStr) {
            var dateObj = new Date(dateStr);
            if (!isNaN(dateObj)) {
              var day = String(dateObj.getDate()).padStart(2, "0");
              var month = String(dateObj.getMonth() + 1).padStart(2, "0"); // Months are zero-based
              var year = dateObj.getFullYear();
              return day + "." + month + "." + year;
            }
            return dateStr; // Return the original value if the date is invalid
          }

          if (startDate || endDate) {
            var formattedStart = startDate ? formatDate(startDate) : "";
            var formattedEnd = endDate ? formatDate(endDate) : "";
            if (formattedStart && formattedEnd) {
              activeFilters.push(`${formattedStart} - ${formattedEnd}`);
            } else if (formattedStart) {
              activeFilters.push(`${formattedStart}`);
            } else if (formattedEnd) {
              activeFilters.push(`${formattedEnd}`);
            }
          }
        }
      }
    });

    // Update the content of the .active-filters span
    var activeFiltersSpan = document.querySelector(".active-filters");
    if (activeFiltersSpan) {
      if (activeFilters.length > 0) {
        activeFiltersSpan.textContent = ": " + activeFilters.join(", ");
      } else {
        activeFiltersSpan.textContent = "";
      }
    }
  });
}

export { changeSliderFacetLabel, activeFacets, showSelectedFilters };
